// ANCHOR Base
import { KIND, Notification } from 'baseui/notification';

// ANCHOR Models
import { useCreateFormQuestionAnswerFormSuccessValue } from '@lyon/scoped-models/form/create/CreateFormQuestionAnswerForm';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';

// ANCHOR Styles
import { NOTIFICATION } from './styles';

// ANCHOR Constants
import { LABEL } from './constants';

export const LyonCreateFormQuestionAnswerNotification = constant(() => {
  const isSuccess = useCreateFormQuestionAnswerFormSuccessValue();

  if (isSuccess) {
    return (
      <Notification kind={KIND.positive} overrides={NOTIFICATION}>
        {LABEL}
      </Notification>
    );
  }

  return null;
});
